import React, { useState } from 'react';
import { Spin, Badge } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import getName from '../../../helpers/getName';
import useRequestComments from '../../../queries/useRequestComments';
import Card, { CardButton, CardHeader } from '../../Card';
import { cutOffOddCharacters } from '../../commentsChat/LastComment/utils/cutOffOddCharacters';
import RequestCommentsModal from '../RequestCommentsModal/RequestCommentsModal';
import styles from './RequestCommentsCard.module.scss';
import { linkify } from '../../../helpers/linkify';

const RequestCommentsCard = ({
  request,
  className,
  canChange = true,
  ...props
}) => {
  const { data: comments, isFetching: isCommentsFetching } = useRequestComments(
    request.id
  );

  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);

  const handleOpenCommentsModal = () => setIsCommentsModalOpen(true);

  const handleCloseCommentsModal = () => setIsCommentsModalOpen(false);

  const lastComment = comments?.length ? comments[comments.length - 1] : null;

  const cardButtonText = lastComment ? (
    <>
      Показать комментарии{' '}
      <Badge
        className={styles.amount}
        style={{ backgroundColor: '#268EFF', marginLeft: '10px' }}
        count={comments?.length}
      />
    </>
  ) : (
    'Добавить комментарий'
  );

  const commentBodyText = lastComment
    ? linkify(cutOffOddCharacters(lastComment.note || ''))
    : 'Комментариев пока нет';

  const metaBlock = lastComment ? (
    <div className={styles.lastCommentMeta}>
      <p className={cn(styles.text, styles.lastCommentMetaData)}>
        {moment(lastComment.date).format('DD-MM-YYYY HH:mm')}
      </p>
      <div className={styles.userContainer}>
        {lastComment.user.specialityName && (
          <p className={cn(styles.text, styles.speciality)}>
            {lastComment.user.specialityName}
          </p>
        )}
        <p className={cn(styles.text, styles.lastCommentMetaData)}>
          {getName(lastComment.user)}
        </p>
      </div>
    </div>
  ) : null;

  const showBtn = comments?.length > 0 || canChange;

  return (
    <Card
      {...props}
      className={cn(styles.root, className)}
    >
      <Spin
        wrapperClassName={styles.spin}
        spinning={isCommentsFetching}
      >
        <CardHeader
          className={styles.header}
          title="Комментарии"
        />
        <div className={styles.content}>
          {metaBlock}
          <p
            className={cn(styles.text, styles.comment)}
            dangerouslySetInnerHTML={{ __html: commentBodyText }}
          />
        </div>
        {showBtn && (
          <CardButton
            className={styles.button}
            block
            text={cardButtonText}
            onClick={handleOpenCommentsModal}
          />
        )}
      </Spin>
      {showBtn && (
        <RequestCommentsModal
          request={request}
          onClose={handleCloseCommentsModal}
          visible={isCommentsModalOpen}
          comments={comments}
          canChange={canChange}
        />
      )}
    </Card>
  );
};

export default RequestCommentsCard;
